import React, { useState, useEffect } from 'react'
import { API_URL } from '../Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import loading1 from "../../assets/loading.gif"

function Trashsms() {
  const [searchTerm, setSearchTerm] = useState('');
  const [Trashsms, setTrashsms] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchTrashsms = () => {
    const getTrashsmsURL = `${API_URL}/get_failed_messages?page=${page}&limit=${50}`;
    axios
      .get(getTrashsmsURL)
      .then(function (response) {
        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setTrashsms([...Trashsms, ...response.data]);
          setPage(page + 1);
        }
      })
      .catch(function (error) {
        // handle errors
        console.log(error?.response);
      });
  };

  useEffect(() => {
    fetchTrashsms();
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    fetchTrashsms();
  };

  const filteredTrashsms = Trashsms.filter((Trashsms) => {
    const { id, phone_no, message_body, created_at } = Trashsms;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      id.toString().toLowerCase().includes(lowerCaseSearchTerm) ||
      phone_no.toLowerCase().includes(lowerCaseSearchTerm) ||
      message_body.toLowerCase().includes(lowerCaseSearchTerm) ||
      created_at.toLowerCase().includes(lowerCaseSearchTerm)
    );
  });

  const loadMoreTrashsms = () => {
    fetchTrashsms(); // Fetch more Trashsms when the user scrolls to the bottom
  };
  return (
    <div style={{ paddingLeft: '10px' }}>
        <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Deleted Messages</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Trash</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>
      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

          <InfiniteScroll

            dataLength={filteredTrashsms.length}
            next={loadMoreTrashsms}
            hasMore={hasMore}
            loader={filteredTrashsms.length > 0 ? null : 
              <div className="loadingsubcontainer">
                <img className="loadingsubimg" src={loading1} alt="" />
              </div>}
            endMessage={<p>No more sms to load.</p>}
          >
            <table id="example" className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Phone No</th>
                  <th>Message</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                  {filteredTrashsms.map((Trashsms) => (
                    <tr key={Trashsms.id}>
                      <td>{Trashsms.id}</td>
                      <td>{Trashsms.phone_no}</td>
                      <td>{Trashsms.message_body}</td>
                      <td>{Trashsms.created_at}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
        </InfiniteScroll>
      
    </div>
  )
}

export default Trashsms